import { render } from "./HowToPayPage.vue?vue&type=template&id=454f2c08"
import script from "./HowToPayPage.vue?vue&type=script&lang=js"
export * from "./HowToPayPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__